export * from './company-representative-relationship.fragment.generated'
